module.exports = __webpack_public_path__ + "img/view_8.2073f1a3.jpg";